/* tslint:disable */
/* eslint-disable */
/**
 * BS2
 * BoostSales 2
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateCallSessionDto
 */
export interface CreateCallSessionDto {
    /**
     * 
     * @type {number}
     * @memberof CreateCallSessionDto
     */
    campaignId: number;
    /**
     * 
     * @type {number}
     * @memberof CreateCallSessionDto
     */
    userId: number;
    /**
     * 
     * @type {number}
     * @memberof CreateCallSessionDto
     */
    partnerId: number;
}

/**
 * Check if a given object implements the CreateCallSessionDto interface.
 */
export function instanceOfCreateCallSessionDto(value: object): value is CreateCallSessionDto {
    if (!('campaignId' in value) || value['campaignId'] === undefined) return false;
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('partnerId' in value) || value['partnerId'] === undefined) return false;
    return true;
}

export function CreateCallSessionDtoFromJSON(json: any): CreateCallSessionDto {
    return CreateCallSessionDtoFromJSONTyped(json, false);
}

export function CreateCallSessionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateCallSessionDto {
    if (json == null) {
        return json;
    }
    return {
        
        'campaignId': json['campaign_id'],
        'userId': json['user_id'],
        'partnerId': json['partner_id'],
    };
}

export function CreateCallSessionDtoToJSON(json: any): CreateCallSessionDto {
    return CreateCallSessionDtoToJSONTyped(json, false);
}

export function CreateCallSessionDtoToJSONTyped(value?: CreateCallSessionDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'campaign_id': value['campaignId'],
        'user_id': value['userId'],
        'partner_id': value['partnerId'],
    };
}

